import { render, staticRenderFns } from "./OTHistory.vue?vue&type=template&id=fb14e8be&scoped=true&lang=pug"
import script from "./OTHistory.vue?vue&type=script&lang=js"
export * from "./OTHistory.vue?vue&type=script&lang=js"
import style0 from "./OTHistory.vue?vue&type=style&index=0&id=fb14e8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb14e8be",
  null
  
)

export default component.exports